import Tabs from '@/components/Tabs/Tabs';
import './home.less';
import { useEffect, useState } from 'react';
import uploadIcon from '@/assets/home/upload.png';
import { Upload } from 'antd';
import { useNavigate } from 'react-router-dom';
import { SDService, projectController } from '@/api';
import UploadProgress from '@/components/UploadProgress/UploadProgress';
import GLBViewer from '@/components/GLBViewer/GLBViewer';
import Uploader from '@/utils/uppyUpload';
import toast from 'react-hot-toast';
import { fileExtension, isFormatFile } from '@/utils/file';

export default function Home() {
  const [tab, setTab] = useState(0);
  const [imageFileInfo, setImageFileInfo] = useState(null);
  const [imageURL, setImageURL] = useState(null);

  const [meshFile, setMeshFile] = useState(null);

  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);

  const testTaskId = false; // 走测试id

  const navigate = useNavigate();

  useEffect(() => {}, []);

  const uploadImage = async () => {
    if (uploading) {
      toast('Waiting for generation to complete');
      return;
    }
    if (!imageFileInfo) {
      toast('Please choose file');
      return;
    }
    const isLt2M = imageFileInfo.file.size / 1024 / 1024 < 20;
    if (!isLt2M) {
      toast('Less than 20MB');
      return;
    }
    try {
      setUploading(true);
      const formData = new FormData();
      formData.append('file', imageFileInfo.file);
      formData.append('name', imageFileInfo.file.name);
      const { code, data } = await SDService.tripo_upload(formData);
      if (code === 0) {
        const { image_token } = data;
        let task_id;
        if (testTaskId) {
          task_id = 'd9ecaa07-b31c-496c-a46f-35fca1608adf';
        } else {
          const res = await SDService.submit_3d({
            imageToken: image_token,
            platformType: '1', // 0 是混元 1 是tripo
          });
          if (res.code === 0) {
            task_id = res.data.task_id;
          }
        }
        const interval = setInterval(async () => {
          const taskRes = await SDService.task_status_3d(task_id);
          if (taskRes.code === 0) {
            const data = taskRes.data;
            const progress = data.progress;
            console.log('progress1==', progress);
            setProgress(progress);
            if (data.status === 'success') {
              clearInterval(interval);
              sessionStorage.setItem('preview_url', data.modelUrl);
              navigate('/preview');
            }
          } else {
            clearInterval(interval);
          }
        }, 2000);
      }
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  // 上传mesh
  const uploadMesh = async () => {
    if (uploadLoading) {
      toast('Waiting for generation to complete');
      return;
    }
    if (!meshFile) {
      toast('Please choose file');
      return;
    }
    const isLt2M = meshFile.size / 1024 / 1024 < 70;
    console.log('isLt2M', isLt2M);
    if (!isLt2M) {
      toast('Less than 70MB');
      return;
    }
    // navigate('/textureUnity');
    // return;
    const fileExtension = meshFile.name.split('.').pop();
    let startTime = new Date().getTime();

    setUploadLoading(true);

    try {
      const upload = new Uploader(9, { ext: fileExtension });
      upload.onComplete = async (result) => {
        const { uploadId, eTags } = result;
        let type = 0;
        if (fileExtension === 'obj') {
          type = 0;
        } else if (fileExtension === 'fbx') {
          type = 1;
        } else if (fileExtension === 'glb') {
          type = 2;
        }

        const res = await projectController.create({
          body: {
            name: '测试',
            streams: [
              {
                type: type, // StreamTypeEnum
                upload: {
                  uploadId: uploadId,
                  completedParts: eTags,
                },
                zIndex: 1,
              },
            ],
            type: 0, // ProjectTypeEnum
            mode: 'texture', // ConsumptionMode
            tempId: '',
          },
        });
        console.log('本次创建项目总耗时(ms)', new Date().getTime() - startTime);

        console.log('res', res);

        if (res.code === 0) {
          // 创建成功
          const { projectId, url } = res.data;
          console.log(res);
          sessionStorage.setItem('texture_model_url', url);
          setUploadLoading(false);
          window.location.href =
            window.location.protocol + '//' + window.location.host + '/texture/' + projectId;
        }
      };

      await upload.uploadFileWithSlice(meshFile);

      // setAvatar({
      //   uploadId: res.uploadId,

      //   completedParts: res.eTags,
      // });
    } catch (error) {
      console.log('结束上传', error);
    }
  };

  console.log('progress2==', progress);
  return (
    <div className="home">
      <div className="downbg"></div>
      <div className="upbg"></div>
      <div className="caption">Let’s get started!</div>
      <div className="caption-desc">
        Ai-generated, creative-led-A fully controllable and editable 3D workflow
      </div>
      <Tabs
        tabs={['Generate Texture', 'Generate 3D model']}
        disabled={uploadLoading || uploading}
        onChange={(item, i) => {
          setTab(i);
        }}></Tabs>
      {tab === 0 ? (
        <>
          <Upload
            beforeUpload={() => false}
            showUploadList={false}
            accept=".glb,.obj,.fbx"
            onChange={(info) => {
              const isLt2M = info.file.size / 1024 / 1024 < 70;
              if (!isLt2M) {
                toast('Less than 70MB');
                return;
              }
              if (isFormatFile(info.file, ['.glb', '.obj', '.fbx'])) {
                setMeshFile(info.file);
              } else {
                toast('Invalid format');
              }
            }}>
            {meshFile ? (
              <div className="texure-tab-content">
                <GLBViewer
                  key={meshFile.name}
                  format={fileExtension(meshFile.name)}
                  onLoadFinish={() => {}}
                  style={{ width: 100, height: 100 }}
                  url={URL.createObjectURL(meshFile)}></GLBViewer>
                {uploadLoading ? (
                  <div className="texure-tab-content-upload">
                    <UploadProgress percent={progress} title="Uploading..."></UploadProgress>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            ) : (
              <div className="texure-tab-content">
                <img className="icon" src={uploadIcon}></img>
                <div className="desc">
                  <span style={{ color: '#A0F00F', textDecoration: 'underline' }}>
                    Click to upload
                  </span>
                  <span> or drag and drop</span>
                </div>
                <div className="suffix">
                  <span>OBJ, FBX and GLB formats. Less than 70MB.</span>
                </div>
              </div>
            )}
          </Upload>
          <div
            className="upload-btn"
            onClick={() => {
              uploadMesh();
            }}>
            Generate
          </div>
        </>
      ) : (
        <>
          <Upload
            beforeUpload={() => false}
            showUploadList={false}
            accept=".jpg,.png"
            onChange={(info) => {
              const isLt2M = info.file.size / 1024 / 1024 < 20;
              if (!isLt2M) {
                toast('Less than 20MB');
                return;
              }
              if (isFormatFile(info.file, ['.jpg', '.png'])) {
                console.log('info', info);
                setImageFileInfo(info);
                setImageURL(URL.createObjectURL(info.file));
              } else {
                toast('Invalid format');
              }
            }}>
            <div className="texure-tab-content">
              {!imageFileInfo ? (
                <>
                  <img className="icon" src={uploadIcon}></img>
                  <div className="desc">
                    <span style={{ color: '#A0F00F', textDecoration: 'underline' }}>
                      Click to upload
                    </span>
                    <span> or drag and drop</span>
                  </div>
                  <div className="suffix">
                    <span>JPG,PNG formats. Less than 20MB.</span>
                  </div>
                </>
              ) : uploading ? (
                <UploadProgress percent={progress}></UploadProgress>
              ) : (
                <img className="upload-image" src={imageURL}></img>
              )}
            </div>
          </Upload>
          <div className="upload-btn" onClick={uploadImage}>
            Generate
          </div>
        </>
      )}
    </div>
  );
}
